import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e08989a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "level"
}


import {RecordedContentVO} from "@/apis/recorded";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainRecordedCatalogItem',
  props: {
    content: {},
    currentId: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_MainRecordedCatalogItem = _resolveComponent("MainRecordedCatalogItem", true)!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      href: '#content' + _ctx.content.id,
      class: _normalizeClass([_ctx.currentId === 'content' + _ctx.content.id && 'active', "catalog-title"])
    }, _toDisplayString(_ctx.content.title), 11, _hoisted_1),
    (_ctx.content.children?.length >0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.children, (item) => {
            return (_openBlock(), _createBlock(_component_MainRecordedCatalogItem, {
              key: 'catalog' + item.id,
              content: item,
              currentId: _ctx.currentId
            }, null, 8, ["content", "currentId"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})